import React from 'react';
import {
  columnType,
  columnCreatedOn,
  columnSize,
  columnTransferable,
  columnViewing,
  hasColumn,
} from '@/constants/fields';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';
import TableSortedColumn from '@/components/table/TableSortedColumn';

const DatasetAttachmentsTableColumns = ({
  columns,
  items,
  onOrderByColumn,
  orderBy,
}) => (
  <NameDescriptionColumns
    category="attachments"
    className="aridhia-dataset-attachments-table-columns sticky"
    columns={columns}
    items={items}
    onOrderByColumn={onOrderByColumn}
    orderBy={orderBy}
    singleSorting
  >
    {hasColumn(columns, 'id') && (
      <TableSortedColumn
        name="id"
        onOrderByColumn={onOrderByColumn}
        orderBy={orderBy}
        singleSorting
        sortable
      />
    )}
    {hasColumn(columns, columnType) && (
      <TableSortedColumn
        name={columnType}
        onOrderByColumn={onOrderByColumn}
        orderBy={orderBy}
        singleSorting
        sortable
      />
    )}
    {hasColumn(columns, columnSize) && (
      <TableSortedColumn
        name={columnSize}
        onOrderByColumn={onOrderByColumn}
        orderBy={orderBy}
        singleSorting
        sortable
      />
    )}
    {hasColumn(columns, columnViewing) && (
      <TableSortedColumn
        name={columnViewing}
        onOrderByColumn={onOrderByColumn}
        orderBy={orderBy}
        singleSorting
        sortable
      />
    )}
    {hasColumn(columns, columnTransferable) && (
      <TableSortedColumn
        name={columnTransferable}
        onOrderByColumn={onOrderByColumn}
        orderBy={orderBy}
        singleSorting
        sortable
      />
    )}
    {hasColumn(columns, columnCreatedOn) && (
      <TableSortedColumn
        name={columnCreatedOn}
        onOrderByColumn={onOrderByColumn}
        orderBy={orderBy}
        singleSorting
        sortable
      />
    )}
  </NameDescriptionColumns>
);

export default DatasetAttachmentsTableColumns;
